import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "email-phone-options-dropdown" }
const _hoisted_2 = { class: "email-phone-options-dropdown__item-text" }
const _hoisted_3 = { class: "email-phone-options-dropdown__item-text" }
const _hoisted_4 = { class: "email-phone-options-dropdown__item-text" }

import {inject, ref} from "vue";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import AppTooltip from "@/components/ui-kit/tooltip/AppTooltip.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ContactsEmailPhoneOptionsDropdown',
  props: {
    type: {}
  },
  emits: ["on-call", "on-email", "on-copy"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const $tooltip = ref<typeof AppTooltip | null>(null)
const closeDropdown = inject<() => void>('appResizableDropdownClose')

const closeOnMobile = () => {
	if (window.innerWidth <= 480) {
		closeDropdown?.()
	}
}

const onCall = () => {
	emit('on-call')
	closeOnMobile()
}

const onEmail = () => {
	emit('on-email')
	closeOnMobile()
}

const onCopy = () => {
	emit('on-copy')
	if (window.innerWidth <= 480) {
		closeOnMobile()
		return
	}
	$tooltip.value?.showByClick()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.type === 'phone')
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "email-phone-options-dropdown__item",
          onClick: onCall
        }, [
          _createVNode(AppIcon, {
            name: "phone",
            width: "14px",
            color: "#979797"
          }),
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('contact_call')), 1)
        ]))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "email-phone-options-dropdown__item",
          onClick: onEmail
        }, [
          _createVNode(AppIcon, {
            name: "envelope",
            width: "14px",
            color: "#979797"
          }),
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('contact_write')), 1)
        ])),
    _createVNode(AppTooltip, {
      ref_key: "$tooltip",
      ref: $tooltip,
      text: _ctx.$t(props.type === 'email' ? 'email_copied' : 'phone_copied'),
      position: "bottom",
      "show-by-activator-click": ""
    }, {
      activator: _withCtx(() => [
        _createElementVNode("div", {
          class: "email-phone-options-dropdown__item",
          onClick: onCopy
        }, [
          _createVNode(AppIcon, {
            name: "copy",
            width: "14px",
            color: "#979797"
          }),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('ui_copy')), 1)
        ])
      ]),
      _: 1
    }, 8, ["text"])
  ]))
}
}

})